import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
const user = {
  state: {
    token: getToken(),
    username: '',
    avatar: '',
    roles: [],
    permissions: [],
    userInfo:{},
    show:false,
  },
  getters:{
    getUserInfo (state) {
      return state.userInfo
    },
    show (state) {
      return state.show
    },
  },
  mutations: {
    setShow:(state,flag)=>{
      state.show=flag
    },
    setUserInfo:(state,user)=>{
      state.userInfo=user
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, username) => {
      state.username = username
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.account.trim()
      return new Promise((resolve, reject) => {
        login(userInfo.type,username, userInfo.password,userInfo.img_code).then(response => {
          // const data = response.data
          // let userInfo=JSON.parse(localStorage.getItem("userInfo"))
          setToken(response.data)
          commit('SET_TOKEN', response.data)
          commit('SET_NAME', username)
          // console.log(response.data,'usernameusername')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data
          console.log(response.data,'response')
          commit("setUserInfo",response.data)
          // if (data.permissions && data.permissions.length > 0) { // 验证返回的roles是否是一个非空数组
            // commit('SET_NAME', data.user.username)
            // commit('SET_PERMISSIONS', data.permissions)
          // } else {
          //   reject('抱歉，您无权限访问');
          // }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONS', [])
        // sessionStorage.removeItem("userInfo")
        commit('setUserInfo',{})
        removeToken()
        // Cookies.remove('userInfo')
        localStorage.removeItem('userInfo')
        resolve()
      })
    }
  }
}

export default user
